const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';

const steps = [
  {
    num: '01',
    title: 'Araç marka/model bilgisini gönder',
    desc: 'WhatsApp üzerinden aracınızın bilgilerini paylaşın.',
  },
  {
    num: '02',
    title: 'Aradığın parçayı belirt',
    desc: 'İhtiyacınız olan yedek parça bilgisini yazın.',
  },
  {
    num: '03',
    title: 'Uygunluk ve fiyat bilgisi al',
    desc: 'Hızlıca parça uygunluğu ve fiyat bilgisi alın.',
  },
  {
    num: '04',
    title: 'Kargo veya teslimat seçeneğini değerlendir',
    desc: 'Türkiye geneli kargo veya yerinde teslimat seçenekleri.',
  },
];

export default function PartsInquiry() {
  return (
    <section id="parca-sorgula" className="relative bg-brand-darker py-20 md:py-28">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          {/* Image */}
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=premium%20automotive%20spare%20parts%20engine%20components%20car%20battery%20oil%20filters%20brake%20pads%20arranged%20professionally%20on%20dark%20background%20cinematic%20red%20accent%20lighting%20high%20end%20workshop%20atmosphere%20photorealistic&width=800&height=600&seq=parts1&orientation=landscape"
                alt="Otomotiv yedek parça"
                className="w-full h-64 md:h-80 lg:h-[420px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/30 to-transparent" />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block bg-brand-accent/20 text-brand-accent text-sm font-bold px-4 py-1.5 rounded-full mb-4">
              Parça Sorgula
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight mb-4">
              Aracınıza Uygun Parçayı{' '}
              <span className="text-brand-accent">Hemen Sorun</span>
            </h2>
            <p className="text-brand-muted text-base md:text-lg leading-relaxed mb-8 md:mb-10">
              Marka, model, yıl ve aradığınız parça bilgisini WhatsApp’tan gönderin. Size uygun seçenekler için hızlıca dönüş yapılsın.
            </p>

            {/* Steps */}
            <div className="space-y-6 md:space-y-8 mb-8 md:mb-10">
              {steps.map((step, idx) => (
                <div key={step.num} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-brand-accent text-white text-sm font-bold shrink-0">
                      {step.num}
                    </span>
                    {idx < steps.length - 1 && (
                      <div className="w-px h-full min-h-[24px] md:min-h-[32px] bg-white/10 mt-2"></div>
                    )}
                  </div>
                  <div className="pb-2">
                    <h4 className="text-white font-semibold text-sm md:text-base mb-1">
                      {step.title}
                    </h4>
                    <p className="text-brand-muted text-sm leading-relaxed">
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-base md:text-lg px-7 py-4 md:py-5 rounded-full transition-all duration-200 shadow-xl shadow-brand-accent/20 active:scale-95"
            >
              Parça Sorgula
              <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-white/20 rounded-full">
                <i className="fas fa-arrow-up-right-from-square text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}